import React, { useState, useCallback, useEffect, useReducer } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input } from '~/components/Form';
import { updateData } from '~/store/modules/padroes/actions';

import { t, number } from '~/helpers';

import * as S from './styles';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { loading, find, params } = useSelector((state) => state.padroes);

  const initials = { ...find, ...data };

  const [posto, setPosto] = useState('');
  const [desc, setDesc] = useState('');
  const [perc, setPerc] = useState('');
  const [acum, setAcum] = useState('');

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        popa_val_dif_max_estoque: Yup.string()
          .typeError('Campo Obrigatório')
          .required('Campo Obrigatório')
          .min(0, 'Valor deve ser igual ou superior a 0')
          .max(
            999999,
            t('s.geral.validacao.tamanhomaximo').replace('%s', 999999)
          ),
        popa_per_acumulado_mes: Yup.string()
          .typeError('Campo Obrigatório')
          .required('Campo Obrigatório')
          .min(0, 'Valor deve ser igual ou superior a 0')
          .max(
            999999,
            t('s.geral.validacao.tamanhomaximo').replace('%s', 999999)
          ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        post_cod_posto: posto,
        post_desc: null,
        popa_val_dif_max_estoque: desc,
        popa_per_dif_max_estoque: perc,
        capacidade: null,
        cont_tafi: null,
        popa_per_acumulado_mes: acum,
      };

      await dispatch(updateData(objSend, params));
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    const {
      post_cod_posto,
      popa_val_dif_max_estoque,
      popa_per_dif_max_estoque,
      popa_per_acumulado_mes,
    } = find;
    setPosto(post_cod_posto);
    setDesc(Number(popa_val_dif_max_estoque).toFixed(2));
    setPerc(Number(popa_per_dif_max_estoque).toFixed(2));
    setAcum(Number(popa_per_acumulado_mes).toFixed(2));
  }, [find]);

  const handleChangePercText = useCallback((value) => {
    let des = value ? Number(value) : 0;
    let per = value ? Number((des / 100000) * 100) : 0;

    setDesc(des);
    setPerc(per);
  }, []);

  const handleDoisPontos = useCallback((value) => {
    let des = value ? Number(value).toFixed(2) : 0;
    let per = value ? Number((des / 100000) * 100).toFixed(2) : 0;
    setDesc(des);
    setPerc(per);
  });

  const handleChangeAcumText = useCallback((value) => {
    let acu = value ? Number(value) : 0;
    setAcum(acu);
  }, []);

  const handleAcumDoisPontos = useCallback((value) => {
    let acu = value ? Number(value).toFixed(2) : 0;
    setAcum(acu);
  });

  if (loading)
    return (
      <div style={{ height: '14rem', width: '50rem' }}>
        <Spinner loading />
      </div>
    );

  return (
    <S.Wrapper ref={reference} initialData={initials} onSubmit={handleSubmit}>
      <Input name="post_desc" label="Posto" disabled={true} />

      <Input
        name="popa_val_dif_max_estoque"
        label="Turno/Descarga Litros"
        type="number"
        value={desc}
        getValue={(value) => {
          handleChangePercText(value);
        }}
        onBlur={({ target }) => handleDoisPontos(target.value)}
      />

      <Input
        name="popa_per_dif_max_estoque"
        label="Turno/Descarga %"
        value={perc}
        disabled={true}
      />

      <Input
        name="popa_per_acumulado_mes"
        label="Acumulado mês %"
        type="number"
        value={acum}
        getValue={(value) => {
          handleChangeAcumText(value);
        }}
        onBlur={({ target }) => handleAcumDoisPontos(target.value)}
      />
    </S.Wrapper>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
